export default {
  title: 'Bucură-te de cea mai bună experiență pe aplicația noastră mobilă',
  description: 'Economisești timp, câștigi recompense, primești notificări despre oferte și multe altele',
  buttons: {
    download: 'Deschide aplicația {{name}}',
  },
};
